












































































































import {
  Vue, Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import splitContent from '@/shared/directive/split-content';
import DateHandler from '@/shared/utils/date-format';
import Pagination from '@/domain/pagination.entity';
import ContractHistory from '@/domain/contract-history/entity/contract-history.entity';
import Response from '@/domain/response.entity';
import ContractHistoryService from '@/domain/contract-history/service/contract-history.service';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Header from './header.json';
import HistoryContent from './history-content.component.vue';
import Types from './type.json';
import ContractInfoTabControl from '../contract-info-tab-index';

@Component({
  components: {
    VbPagination, HistoryContent, VbTooltipSlot, MainButton,
  },
  filters: {
    splitContent,
    formatDate(value: string) {
      return DateHandler.fullDateAndTime(value);
    },
  },
})

export default class HistoryComponent extends Vue {
  @Prop({
    required: false,
  })
  businessUnitId!: string;

  @Prop({
    required: false,
  })
  contractId!: string;

  @Prop({
    required: true,
  })
  tabControl!: ContractInfoTabControl;

  history: Array<ContractHistory> = [];

  selectedHistory: ContractHistory = ContractHistory.of()

  selectedType: any;

  types = Types;

  header = Header;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 5,
  });

  updateTable(pagination: Pagination) {
    this.pagination = pagination;
    this.pagination.verifyPage();
    this.getHistory();
  }

  created() {
    this.getHistory();
  }

  @Watch('tabControl')
  getHistory() {
    if (this.tabControl !== ContractInfoTabControl.HISTORICO) {
      return
    }
    ContractHistoryService.get(
      this.businessUnitId, this.contractId, this.selectedType, this.pagination,
    ).then((response: Response) => {
      this.history = ContractHistory.ofList(response.content);
      this.pagination.total = response.totalElements;
      this.pagination.pageCount = response.totalPages;
      this.selectedHistory = this.history[0]
    });
  }
}
